import { render, staticRenderFns } from "./StudentOverview.vue?vue&type=template&id=a46c5df0&scoped=true&"
import script from "./StudentOverview.vue?vue&type=script&lang=js&"
export * from "./StudentOverview.vue?vue&type=script&lang=js&"
import style0 from "./StudentOverview.vue?vue&type=style&index=0&id=a46c5df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c5df0",
  null
  
)

export default component.exports